export default "__VITE_PUBLIC_ASSET__bad5f9e8__"